import { render, staticRenderFns } from "./BaskoBoxConfirmConsent.vue?vue&type=template&id=4cdd41ab&"
import script from "./BaskoBoxConfirmConsent.vue?vue&type=script&lang=js&"
export * from "./BaskoBoxConfirmConsent.vue?vue&type=script&lang=js&"
import style0 from "./BaskoBoxConfirmConsent.vue?vue&type=style&index=0&id=4cdd41ab&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports